
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ultimos-comentarios/[[...lastCommentsParams]]",
      function () {
        return require("private-next-pages/ultimos-comentarios/[[...lastCommentsParams]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ultimos-comentarios/[[...lastCommentsParams]]"])
      });
    }
  